<template>
  <div v-if="errorMessagesFlat.length > 0" class="error-messages-area">
    <div v-for="(errorMessage, index) in errorMessagesFlat" :key="index">
      <div class="d-flex" :class="index !== 0 ? 'mt-2' : ''">
        <div class="error-icon-area">
          <img src="~/assets/images/icons/ic_error_exclamation.png" alt="Error" class="mr-2 error-icon" />
        </div>
        <div>{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  errorMessages: Record<string, string[]> | string[];
}>();

const errorMessagesFlat = computed(() => {
  return Object.values(props.errorMessages).flat();
});
</script>

<style lang="scss" scoped>
@use '~/assets/scss/_base.scss' as vars;

.error-messages-area {
  padding: 12px;
  margin-top: 16px;
  font-size: 14px;
  color: vars.$color-danger;
  background-color: #FEE3E3;
  border-radius: 4px;

  .error-icon-area {
    width: 24px;
  }

  .error-icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
}
</style>
